import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Translation} from '../../models/translation';
import {ChangePasswordService} from '../../services/change-password.service';
import {TranslationService} from '../../services/translation.service';
import Swal from 'sweetalert2';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  public translation: Translation;
  public pwd1: string;
  public pwd2: string;
  public token: string;
  public userId: number;
  public disabled = false;
  public translationVersion = environment.translationVersion;

  public toast = Swal.mixin({ toast: true, position: 'top-right', timer: 5000, timerProgressBar: true, showConfirmButton: false});

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private changePasswordService: ChangePasswordService,
    private translationService: TranslationService
  ) { }

  ngOnInit(): void {
    if (localStorage.getItem('Translation') === null) {
      this.toast.fire('Downloading language package', '', 'info');
      localStorage.setItem('Language', 'DE');
      this.translationService.getTranslation(localStorage.getItem('Language')).subscribe(responseTranslation => {
        if (responseTranslation.Ok) {
          localStorage.setItem('Translation', JSON.stringify(responseTranslation.Obj));
          this.translation = JSON.parse(localStorage.getItem('Translation'));
          this.activatedRoute.queryParams.subscribe(params => {
            this.userId = params.userId;
            this.token = params.token;
            this.changePasswordService.resetPasswordProcessPartTwo(this.token).subscribe(responsePwChange => {
              if (responsePwChange.Ok) {
                if (!responsePwChange.Obj) {
                  Swal.fire(this.translation.Error, this.translation.ResetPasswordNotification4, 'error');
                  this.disabled = true;
                }
              } else if (responsePwChange.Msg === 'Internal Server Error') { console.log(responsePwChange.Ex); }
              if (responsePwChange.Msg) { this.toast.fire({title: responsePwChange.Msg, icon: responsePwChange.Ok ? 'success' : 'error'}); }
            }, error => { this.toast.fire('Internal Server Error'); });
          }, error => { this.toast.fire(this.translation.InternalServerError); });
        } else if (responseTranslation.Msg === 'Internal Server Error') { console.log(responseTranslation.Ex); }
        if (responseTranslation.Msg) { this.toast.fire({title: responseTranslation.Msg, icon: responseTranslation.Ok ? 'success' : 'error'}); }
      }, error => { this.toast.fire('Internal Server Error'); });
    } else if (+JSON.parse(localStorage.getItem('Translation')).TranslationVersion !== this.translationVersion) {
      this.toast.fire('Downloading language package', '', 'info');
      this.translationService.getTranslation(localStorage.getItem('Language')).subscribe(responseTranslation => {
        if (responseTranslation.Ok) {
          localStorage.setItem('Translation', JSON.stringify(responseTranslation.Obj));
          this.translation = JSON.parse(localStorage.getItem('Translation'));
          this.activatedRoute.queryParams.subscribe(params => {
            this.userId = params.userId;
            this.token = params.token;
            this.changePasswordService.resetPasswordProcessPartTwo(this.token).subscribe(response => {
              if (!response.Ok) {
                Swal.fire(this.translation.Error, this.translation.ResetPasswordNotification4, 'error');
                this.disabled = true;
              } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
              if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
            }, error => { this.toast.fire(this.translation.InternalServerError); });
          }, error => { this.toast.fire(this.translation.InternalServerError);
          });
        } else if (responseTranslation.Msg === 'Internal Server Error') { console.log(responseTranslation.Ex); }
        if (responseTranslation.Msg) { this.toast.fire({title: responseTranslation.Msg, icon: responseTranslation.Ok ? 'success' : 'error'}); }
      }, error => { this.toast.fire(this.translation.InternalServerError); });
    } else {
      this.translation = JSON.parse(localStorage.getItem('Translation'));
      this.activatedRoute.queryParams.subscribe(params => {
        this.userId = params.userId;
        this.token = params.token;
        this.changePasswordService.resetPasswordProcessPartTwo(this.token).subscribe(response => {
          if (!response.Ok) {
            Swal.fire(this.translation.Error, this.translation.ResetPasswordNotification4, 'error');
            this.disabled = true;
          } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
          if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
        }, error => { this.toast.fire(this.translation.InternalServerError); });
      });
    }
  }

  changePassword() {
    if (this.pwd1 !== this.pwd2) {
      Swal.fire(this.translation.Error, this.translation.ResetPasswordNotification5, 'error');
    }
    else if (this.pwd1.length < 8) {
      Swal.fire(this.translation.Error, this.translation.ResetPasswordNotification6, 'error');
    }
    else {
      this.changePasswordService.resetPasswordProcessPartThree(this.token, this.pwd1).subscribe(response => {
        if (response.Ok) {
          if (response.Obj) {
            Swal.fire(this.translation.Success, this.translation.ResetPasswordNotification7, 'success').then(o => {
              this.router.navigate(['/login']).then(r => r);
            });
          } else {
            Swal.fire(this.translation.Error, this.translation.ResetPasswordNotification8, 'error');
          }
        } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
        if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
      }, error => { this.toast.fire(this.translation.InternalServerError); });
    }
  }
}
